<template>
  <div id="home">
    <div class="banner">
      <img src="../../assets/about/about_banner.png" class="banner_img" alt />
    </div>
    <div class="content">
      <div class="tab">
        <ul class="tab_ul">
          <li :class="{active:0==numm}" @click="numm=0">企业介绍</li>
          <li :class="{active:1==numm}" @click="numm=1">奖项荣誉</li>
          <li :class="{active:2==numm}" @click="numm=2">新闻资讯</li>
          <li :class="{active:3==numm}" @click="numm=3">联系我们</li>
        </ul>
      </div>
      <!-- 1 -->
      <div class="tab_one" v-show="numm == 0">
        <div class="tab_one_con">
          <div class="tab_one_ai">
            <div class="tab_one_ai1">
              <img src="../../assets/about/about_tit_01.png" alt />
              <p>关于今云·AI拓客</p>
            </div>
            <p class="nat_p">
              <span>今云AI拓客：</span>由商汇（天津）信息技术有限公司投入三百余万元，百人技术团队研发的拥有自主知识产权的应用产品。今云AI拓客致力于提升企业里每个人的推广能力，帮助企业打造全民营销，创建私域流量池，实现数字化转型升级。企业可以通过AI拓客王为每个员工提供智能名片、智能宣传册、案例库、智能文件夹作为对外展示的工具，通过企业文库、海报系统、短视频系统作为对外传播的工具，通过雷达系统实时传递商机并追溯每次传播的人脉关系，无论线上线下、何时成交，每一份贡献/佣金都将得到合理分配，凝聚企业里每个人参与到销售中来。最后，通过商城系统和CRM管理组件，将企业打造成推广与成交闭环的数字化平台。
            </p>
            <p class="nat_p">
              <span>商汇(天津)信息技术有限公司：</span> 专注于AI及大数据应用研发，在历史的机遇下，结合习近平总书记在背景人民大会堂主持召开民营企业座谈会并发表严重讲话等政策和深厚的技术及资源背景孕育而生的，公司主要为各地政府部门、商协会及企业提供信息化建设应用服务。主要产品有：标准化网上工商联系统、基于商会的一站式企业服务平台商企服、商协会会员管理服务系统新商会、企业客户管理拓客及商城等应用系统AI拓客王等。商汇公司已经为多地政府部门及数千家企业提供应用软件系统服务，
              <span
                style="color:#337EFF;font-weight:400"
              >是专门的政府及企业“数字化转型”服务商。</span>
            </p>
          </div>
          <div class="tab_one_ce">
            <div class="tab_one_ce1">
              <p>
                <img src="../../assets/about/about_tit_02.png" alt />
              </p>
              <p>承载七大商务生态系统</p>
            </div>
            <div class="tab_one_ce2">
              <ul class="uls">
                <li>
                  <img src="../../assets/about/about-a_icon_01.png" alt />
                  <p class="uls_p">移动官网系统</p>
                  <p class="uls_p1">帮助企业标准化输入产品，颠覆传统传统官网，全面提升品牌曝光</p>
                </li>
                <li>
                  <img src="../../assets/about/about-a_icon_02.png" alt />
                  <p class="uls_p">人脉商城系统</p>
                  <p class="uls_p1">帮助企业快速搭建独立商城，加速流量变现，社交变成交，实现全民营销</p>
                </li>
                <li>
                  <img src="../../assets/about/about-a_icon_03.png" alt />
                  <p class="uls_p">智能物料系统</p>
                  <p class="uls_p1">企业文库、品牌海报、获客文章、带货短视频等全部数字化，线上重复传递，降低成本</p>
                </li>
                <li>
                  <img src="../../assets/about/about-a_icon_04.png" alt />
                  <p class="uls_p">BOOS管理系统</p>
                  <p class="uls_p1">帮助企业实现员工和客户双向管理。客户资源不再流失，全面沉淀企业客户资产</p>
                </li>
              </ul>
              <img src="../../assets/about/about-a_img.png" class="uls_img" />
              <ul class="uls">
                <li>
                  <img src="../../assets/about/about-a_icon_05.png" alt />
                  <p class="uls_p">智能名片系统</p>
                  <p class="uls_p1">帮助企业裂变流量，基于10几亿流量池，颠覆传统名片，打造专属IP形象，从而快速引流</p>
                </li>
                <li>
                  <img src="../../assets/about/about-a_icon_06.png" alt />
                  <p class="uls_p">AI雷达系统</p>
                  <p class="uls_p1">帮助企业精准获客，以AI核心算法测算，分析客户行为、兴趣、意向</p>
                </li>
                <li>
                  <img src="../../assets/about/about-a_icon_07.png" alt />
                  <p class="uls_p">微信客服系统</p>
                  <p class="uls_p1">帮助企业打破沟通壁垒，不用加微信也可以直接沟通，把握商机，服务即时响应</p>
                </li>
                <li>
                  <img src="../../assets/about/about-a_icon_08.png" alt />
                  <p class="uls_p">更多功能</p>
                  <p class="uls_p1">系统将不断升级，增加更多功能</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="tab_two" v-show="numm == 1">
        <div class="tab_two_img">
          <img src="../../assets/about/about-b.png" class />
        </div>
      </div>
      <div class="tab_three" v-show="numm == 2">
        <div class="tab_three_con">
          <div class="tab_three_left">
            <p class="left_p">新闻资讯</p>
            <img src="../../assets/about/about-c_line.png" alt />
            <p class="left_p1" @click="classify1()">
              <img src="../../assets/about/about-c_icon_cp_sel.png" v-show="classify == 1" alt />
              <img src="../../assets/about/about-c_icon_cp_noe.png" v-show="classify == 2" alt />
              <span>产品动态</span>
            </p>
            <p class="left_p1" @click="classify2()">
              <img src="../../assets/about/about-c_icon_hy_sel.png" v-show="classify == 2" alt />
              <img src="../../assets/about/about-c_icon_hy_nor.png" v-show="classify == 1" alt />
              <span>行业动态</span>
            </p>
          </div>
          <div class="tab_three_right">
            <div class="tab_three_righr_p">
              <img src="../../assets/about/about-c_bg.png" alt />
              <p class="right_p" v-show="classify == 1">产品动态</p>
              <p class="right_p" v-show="classify == 2">行业动态</p>
            </div>
            <ul class="three_ul">
              <li v-for="(item,index) in list" :key="index">
                <div class="three_li">
                  <p>{{item.created_at}}</p>
                </div>
                <div class="three_li_right">
                  <p>{{item.title}}</p>
                  <p v-html="item.content">{{item.content}}</p>
                  <p @click="details(item.id)">
                    <img src="../../assets/about/about-c_btn_more.png" alt />
                    <span>查看详情</span>
                  </p>
                </div>
              </li>
            </ul>
            <div class="fenye">
              <el-pagination background layout="prev, pager, next" :total="total"></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="tab_four" v-show="numm == 3">
        <div class="tab_four_con">
          <div class="tab_one_ai2">
            <img src="../../assets/about/about-d_tit_contact.png" alt />
            <p>联系我们</p>
          </div>
          <ul class="four_li">
            <li>
              <p>
                <img src="../../assets/about/about-d_icon_tel.png" alt />
              </p>
              <p>客服热线</p>
              <p>022-8821-9596</p>
            </li>
            <li>
              <p>
                <img src="../../assets/about/about-d_icon_tel.png" alt />
              </p>
              <p>公司地址</p>
              <p class="dizhi" style="color:#333333;font-size:18px;font-weight:400;">天津市河西区网信大厦9层</p>
            </li>
          </ul>
        </div>
        <div class="excer">
          <div class="excer_con">
            <div id="allmap" ref="allmap"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { getconsulting } from "@/config/api";
export default {
  data() {
    this.$emit("footer", true); //是否显示头部
    return {
      numm: 0,
      classify: 1,
      list: [],
      total: 0
    };
  },
  methods: {
    apply() {},
    home() {
      this.$router.push({
        name: "home"
      });
    },
    details(id) {
      this.$router.push({
        name: "details",
        query:{
          id:id
        }
      });
    },
    map() {
      var map = new window.BMap.Map("allmap"); //创建地图
      map.enableScrollWheelZoom(); ////启用滚轮放大缩小
      var point = new window.BMap.Point(117.247284, 39.087109); //设置地图位置
      map.centerAndZoom(point, 20);
      var marker = new window.BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panBy(550, 200); //中心点偏移多少像素（width,height）为div 宽高的1/2;
    },
    getlist() {
      getconsulting({
        classify: this.classify,
        page: 1,
        page_size: 5
      }).then(res => {
        this.list = res.data.content;
        this.total = res.data.total;
      });
    },
    classify1() {
      this.classify = 1;
      this.getlist();
    },
    classify2() {
      this.classify = 2;
      this.getlist();
    }
  },
  mounted() {
    this.map();
  },
  created() {
    this.getlist();
    this.numm = this.$route.query.numm;
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background-color: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background-color: #409eff;
}

.add {
  margin-left: 5px;
}

.banner {
  width: 100%;
  height: 400px;
  position: relative;
}

.banner_img {
  width: 100%;
  height: 400px;
}

.divs {
  width: 760px;
  height: 102px;
  position: absolute;
  top: 148px;
  left: 50%;
  margin-left: -380px;
}

.divs img {
  width: 760px;
  height: 116px;
  text-align: center;
  font-size: 46px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin: 0 auto;
}

.chan {
  width: 160px;
  height: 42px;
  background: linear-gradient(
    90deg,
    rgba(255, 207, 136, 1),
    rgba(255, 189, 119, 1)
  );
  border-radius: 4px;
  margin: 40px auto;
  text-align: center;
  line-height: 42px;
  color: #65513d;
  cursor: pointer;
}

.products,
.productsa {
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.content {
  width: 100%;
}

.tab {
  width: 100%;
  height: 60px;
  background: #f1f4f8;
}

.tab_ul {
  width: 1200px;
  margin: 0 auto;
}

.tab_ul li {
  width: 300px;
  float: left;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}

.tab_ul li.active {
  background: #fff;
  color: #337eff;
}

.tab_one {
  width: 100%;
}

.tab_one_con {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.tab_one_ai1 {
  width: 302px;
  margin: 0 auto;
  margin-top: 99px;
  margin-bottom: 79px;
}

.tab_one_ai2 {
  width: 243px;
  margin: 0 auto;
  margin-top: 99px;
  margin-bottom: 79px;
}

.tab_one_ce1 {
  width: 340px;
  margin: 0 auto;
  margin-top: 99px;
  margin-bottom: 79px;
}

.tab_one_ce1 img {
  margin: 0 auto;
  text-align: center;
}

.tab_one_ai1 p,
.tab_one_ce1 p,
.tab_one_ai2 p {
  margin-top: -25px;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}

.nat_p span {
  font-weight: 700;
  color: #333333;
}

.nat_p {
  color: #666666;
  margin-bottom: 50px;
  line-height: 28px;
}

.uls {
  float: left;
}

.uls li {
  margin-bottom: 29px;
}

.uls li img {
  width: 46px;
  height: 46px;
  float: left;
  margin-right: 16px;
  margin-top: 7px;
}

.uls_p {
  font-size: 20px;
  font-weight: 600;
}

.uls_p1 {
  width: 360px;
  height: 39px;
  font-size: 14px;
  color: #9fa19f;
  line-height: 20px;
}

.uls_img {
  margin-top: -40px;
  margin-left: 36px;
  margin-right: 36px;
  float: left;
}

.tab_one_ce {
  width: 100%;
  margin-bottom: 99px;
  overflow: hidden;
}

.tab_two_img {
  width: 1080px;
  margin: 0 auto;
  margin-top: 90px;
}

.tab_three_con {
  width: 1200px;
  margin: 100px auto;
}

.tab_three_left {
  width: 240px;
  margin-right: 50px;
  float: left;
}

.left_p {
  font-size: 20px;
  font-weight: 600;
  margin-left: 9px;
  margin-bottom: 26px;
}

.left_p1 {
  margin-top: 14px;
  cursor: pointer;
  border-bottom: 1px solid #ebedf0;
  overflow: hidden;
}

.left_p1 img {
  margin-left: 8px;
  margin-right: 17px;
  float: left;
  margin-bottom: 14px;
}

.left_p1 span {
  font-weight: 700;
}

.tab_three_right {
  width: 900px;
  float: right;
}

.tab_three_righr_p {
  width: 900px;
  height: 54px;
  position: relative;
  margin-bottom: 30px;
}

.tab_three_righr_p p {
  position: absolute;
  top: 13px;
  left: 19px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-left: 4px solid #ffffff;
  padding: 0 20px;
}

.three_ul li {
  width: 100%;
  height: 168px;
  border-bottom: 1px solid #ebedf0;
  margin-bottom: 30px;
}

.three_li {
  width: 93px;
  float: left;
  margin-right: 30px;
}

.three_li p:first-child {
  color: #666666;
  font-size: 33.05px;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  opacity: 0.6;
}

.three_li p:last-child {
  color: #9fa19f;
  font-size: 20px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
  opacity: 0.6;
}

.three_li_right {
  width: 777px;
  float: right;
}

.three_li_right p:nth-child(1) {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 18px;overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
}

.three_li_right p:nth-child(2) {
  height: 53px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
  overflow: hidden;
  margin-bottom: 16px;
}

.three_li_right p:nth-child(3) {
  width: 85px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 126, 255, 1);
  cursor: pointer;
}

.three_li_right p:nth-child(3) img {
  float: right;
  margin-right: 8px;
}

.fenye {
  margin-left: 123px;
  margin-bottom: 100px;
  margin-top: 20px;
}

.tab_four {
  width: 100%;
  overflow: hidden;
}

.tab_four_con {
  width: 1080px;
  margin: 0 auto;
  margin-bottom: 107px;
  overflow: hidden;
}

.four_li li {
  width: 217px;
  margin-left: 150px;
  float: left;
}

.four_li li:nth-child(2) {
  margin-left: 300px;
}

.four_li li img {
  margin: 0 auto;
}

.four_li li p {
  text-align: center;
}

.four_li li p:nth-child(2) {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin: 29px 0;
}

.four_li li p:nth-child(3) {
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 126, 255, 1);
}

.excer {
  width: 100%;
  height: 458px;
  background: rgba(250, 251, 253, 1);
}
.excer_con {
  width: 1080px;
  margin: 0 auto;
}
#allmap {
  height: 460px;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/about/about.vue